<template>
  <div class="progress-bar-container">
    <div class="progress-bar" :style="{ width: progress + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
      validator(value) {
        return value >= 0 && value <= 100;
      },
    },
  },
};
</script>

<style scoped>
.progress-bar-container {
  width: 100%;
  height: 6px;
  background-color: #bababa;
  border-radius: 8px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #188DFF;
  transition: width 0.3s ease-in-out;
}
</style>
